
"use client";

import Script from 'next/script';

export default function SmilesDrawerScriptLoader() {
  return (
    <Script
      src="https://unpkg.com/smiles-drawer@2.0.1/dist/smiles-drawer.min.js" // Changed to version 2.0.1
      strategy="lazyOnload"
      onLoad={() => {
        // Optional: log when script is loaded, useful for debugging
        // console.log('SDR DEBUG: SmilesDrawer script (v2.0.1) loaded from unpkg.');
      }}
      onError={(e) => {
        // console.error('SDR ERROR: Error loading SmilesDrawer script (v2.0.1) from unpkg:', e);
      }}
    />
  );
}
